export default function Spinner({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-3 text-zinc-400" role="status">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-zinc-200 border-t-brand-600" />
      {label && <p className="text-sm">{label}</p>}
      <span className="sr-only">{label ?? 'Loading'}</span>
    </div>
  );
}
